import { Component, Input } from '@angular/core';
import { ListItemComponent, ListViewComponent } from 'components/layout/list-view/list-view.component';
import { SettlementStatus } from 'enums/SettlementStatus';
import { SettlementModel } from 'models/generated/Entities.GormCrm.Settlement';
import { TranslatePipe } from 'pipes/translate.pipe';
import { SettlementService } from 'services/settlement.service';

@Component({
	selector: 'settlement-status',
	templateUrl: './settlement-status.component.html',
	imports: [ListViewComponent, ListItemComponent, TranslatePipe]
})
export class SettlementSatusComponent {

	public settlementStatus = SettlementStatus;
	@Input() public settlement?: SettlementModel;

	constructor(public readonly settlementService: SettlementService) { }
}
